import { createReducer } from "@reduxjs/toolkit";
import { TYPES } from "../../common/constants";

const addSuiteOnBoardingConveyanceFormListByPropertyCSV = (serviceRequest, { payload }) => {
  return {
    payload,
  };
}

const clearSuiteOnBoardingConveyanceFormListByPropertyCSV = () => {
  return initialState;
};

let initialState ={payload:[]};

export default createReducer(initialState, {
  [TYPES.CLEAR_SUITE_ONBOARDING_CONVEYANCE_FORM_LIST_BY_PROPERTY_CSV]: clearSuiteOnBoardingConveyanceFormListByPropertyCSV,
  [TYPES.ADD_SUITE_ONBOARDING_CONVEYANCE_FORM_LIST_BY_PROPERTY_CSV]: addSuiteOnBoardingConveyanceFormListByPropertyCSV,
});
